import { RouterProvider } from "react-router-dom";
import { AuthenticateProvider } from "./hooks/AuthenticateContext";
import { StatusProvider } from "./hooks/StatusContext";
import router from "./routes";
import { useAxiosInterceptor } from "./services/interceptors";
import { PaykitProvider } from "./hooks/PaykitContext";
import { Toaster } from "sonner";

function App() {
  useAxiosInterceptor();

  return (
    <div className="flex w-full min-h-dvh">
      <AuthenticateProvider>
        <StatusProvider>
          <PaykitProvider>


            <Toaster richColors position="top-right" />
            <RouterProvider router={router} />


          </PaykitProvider>
        </StatusProvider>
      </AuthenticateProvider>
    </div>
  );
}

export default App;
